import React from "react";
import { useI18n } from "../i18n";

/**
 * Methodology / disclaimer block shown on Overview, Daily Plan and Weekly Plan,
 * as well as at the end of the exported PDF. Visible by default (the user
 * asked for it to be readable, not hidden behind a tooltip).
 */
const MethodologyDisclaimer = () => {
  const { t } = useI18n();
  return (
    <div
      className="mt-6 p-4"
      style={{ background: "#141416", border: "1px solid #27272A", borderLeft: "3px solid #F59E0B" }}
      data-testid="methodology-disclaimer"
    >
      <div className="font-mono text-[10px] tracking-widest text-amber-400 mb-2">
        ⓘ {t.plan.disc_title?.toUpperCase()}
      </div>
      <p className="text-sm text-white/80 leading-relaxed m-0">
        {t.plan.disc_body}
      </p>
    </div>
  );
};

export default MethodologyDisclaimer;
